'use strict'

const masterOracleAbi = require('./abi/MasterOracle.json')

const createMasterOracle = function (web3, { address }) {
  const masterOracleAddresses = {
    1: '0x80704Acdf97723963263c78F861F091ad04F46E2',
    10: '0x0aac835162D368F246dc71628AfcD6d2930c47d3',
    43114: '0x5E71EFc852e97124A870B70BA19Cbc96d895DB5E',
    56: '0x5323F445A8665239222b117aE095423a238F5706'
  }

  const getMasterOracleAddress = function () {
    if (address) {
      return Promise.resolve(address)
    }
    return web3.eth.getChainId().then(function (chainId) {
      if (!masterOracleAddresses[chainId]) {
        throw new Error(`Master Oracle address not found for chain ${chainId}`)
      }
      return masterOracleAddresses[chainId]
    })
  }

  return getMasterOracleAddress().then(function (masterOracleAddress) {
    const masterOracleContract = new web3.eth.Contract(
      masterOracleAbi,
      masterOracleAddress
    )

    const getPriceInUsd = token =>
      masterOracleContract.methods.getPriceInUsd(token).call()

    const quote = (tokenIn, tokenOut, amountIn) =>
      masterOracleContract.methods.quote(tokenIn, tokenOut, amountIn).call()

    const quoteTokenToUsd = (token, amountIn) =>
      masterOracleContract.methods.quoteTokenToUsd(token, amountIn).call()

    const quoteUsdToToken = (token, amountIn) =>
      masterOracleContract.methods.quoteUsdToToken(token, amountIn).call()

    return {
      getPriceInUsd,
      quote,
      quoteTokenToUsd,
      quoteUsdToToken
    }
  })
}

module.exports = createMasterOracle
